import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Separator from '@ublend-npm/aulaui-next-web/Separator';
import {
  Wrapper,
  SideBarTitle,
  SideBarFooter,
  FooterLink,
  TextButtonStyles,
} from './SideBar.styled';
import PinnedPostCard from './Card/PinnedPostCard.container';
import PinIcon from '../../PinIcon/PinIcon';
import TextButton from '../../../../common/Buttons/TextButton';
import { analyticsTrackEvent } from '../../../../../../../core/utils/analytics';
import { ALL_IMPORTANT_POSTS_VIEW_FROM_SIDEBAR } from '../../../../../../../core/constants/analytics';

const SideBar = memo(
  ({ spaceId, importantPostsCount, importantPosts, openImportantPosts }) => {
    const handleOpenImportantPosts = () => {
      openImportantPosts();
      analyticsTrackEvent(ALL_IMPORTANT_POSTS_VIEW_FROM_SIDEBAR, {
        activeClassroom: spaceId,
      });
    };

    const totalImportantPostsCount = importantPostsCount;
    const fetchedImportantPostsCount = importantPosts.length;

    const topImportantPosts = importantPosts.slice(0, 3);
    const pinnedPostsLabel =
      totalImportantPostsCount === 1
        ? `${totalImportantPostsCount} pinned post`
        : `all ${totalImportantPostsCount} pinned posts`;

    return (
      <Wrapper
        data-testid="pinned-posts-sidebar"
        noFetchedPosts={!fetchedImportantPostsCount}
      >
        <SideBarTitle>
          <PinIcon />
          <span>Pinned posts ({totalImportantPostsCount})</span>
        </SideBarTitle>
        <Separator />

        {topImportantPosts.map((post) => (
          <PinnedPostCard
            key={post.objectId}
            postId={post.objectId}
            spaceId={post.classRoom}
            user={post.user}
            time={post.createdAt}
            content={post.content}
          />
        ))}

        <SideBarFooter noFetchedPosts={!fetchedImportantPostsCount}>
          <Separator />
          <FooterLink>
            <TextButton
              label={`View ${pinnedPostsLabel}`}
              onClick={handleOpenImportantPosts}
              buttonStyles={TextButtonStyles}
            />
          </FooterLink>
        </SideBarFooter>
      </Wrapper>
    );
  }
);

SideBar.propTypes = {
  spaceId: PropTypes.string.isRequired,
  importantPostsCount: PropTypes.number.isRequired,
  openImportantPosts: PropTypes.func.isRequired,
  importantPosts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SideBar;
